import { ChatResponse } from "@app/core/chat/domain/model/chat-response";

/**
 * Single source of truth for the `/aiball_chat/chat/stream/` wire contract.
 *
 * The endpoint streams Server-Sent Events; each frame is a JSON payload with a
 * `type` field (`delta` | `done` | `error`). This mapper owns the request body
 * and the mapping of the final `done` payload into a {@link ChatResponse}.
 *
 * Conversations are kept server-side: there is no "create thread" call. Omitting
 * `conversation_id` opens a thread, and the id comes back in the `done` frame;
 * sending it back continues that thread.
 */
export class ChatMapper {
  static serializeRequest(
    question: string,
    conversationId: string | null
  ): Record<string, any> {
    return {
      message: question,
      test_version: null,
      save_to_db: true,
      // Omitted entirely on the first turn — sending `null` would not open a
      // thread any differently, but the backend documents the field as absent.
      ...(conversationId === null ? {} : { conversation_id: conversationId }),
    };
  }

  static deserialize(response: any): ChatResponse {
    return {
      response: response?.response ?? "",
      conversationId: response?.conversation_id ?? null,
      questionId: response?.question_id ?? null,
      responseId: response?.response_id ?? null,
    };
  }
}
